<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="backdrop-area"></div>
            <div class="modal-content">
                <div class="flex ">
                    <div class="m-auto p-4">
                        <img class="m-auto rounded-20" src="../../../../assets/gif/bk-loading.gif">
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop-loading" v-if="open"></div>
    </transition>
</template>
<script>
export default {
    name: "LoadingModal",
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        z-index: 1055;

        .modal-content {
            width: 200px;
        }
    }

    .modal-backdrop-loading {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 1053;
        background-color: rgba(0,0,0, 0.5);
    }
</style>
